import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSEO, applySEOTags } from "@/hooks/use-seo";

const SLUG_TO_NAME: Record<string, string> = {
  "/": "Accueil",
  "/aide": "Centre d'aide",
  "/confidentialite": "Politique de confidentialité",
  "/login": "Connexion",
  "/register": "Inscription",
};

export default function SEOHead() {
  const { pathname } = useLocation();
  const slug = pathname === "/" ? "/" : pathname.replace(/\/$/, "");

  // Don't touch metas on internal dashboard routes — they are irrelevant for SEO
  const isAppRoute = slug.startsWith("/app");

  const { data: metadata } = useSEO(slug, { enabled: !isAppRoute });

  useEffect(() => {
    if (isAppRoute) return;
    const pageName = SLUG_TO_NAME[slug] || slug.split("/").pop() || "";
    applySEOTags(metadata ?? null, pageName);
  }, [metadata, slug, isAppRoute]);

  return null;
}
